import { createFileRoute, Link } from "@tanstack/react-router";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import { BLOG_POSTS, formatPostDate } from "@/lib/blog-posts";
import { buildBreadcrumbSchema, ldScript, pageHead, SITE_URL, BUSINESS_ID } from "@/lib/page-schema";

const TITLE = "Blog | Atlanta Luxury Sprinters";
const DESC =
  "Practical advice on booking luxury transportation in Atlanta from Maria Priestly, owner of Atlanta Luxury Sprinters: what to ask before a deposit, holiday party planning and more.";

export const Route = createFileRoute("/blog/")({
  head: () =>
    pageHead({
      path: "/blog",
      title: TITLE,
      description: DESC,
      scripts: [
        ldScript({
          "@context": "https://schema.org",
          "@type": "Blog",
          url: `${SITE_URL}/blog`,
          name: "Atlanta Luxury Sprinters Blog",
          publisher: { "@id": BUSINESS_ID },
          blogPost: BLOG_POSTS.map((p) => ({
            "@type": "BlogPosting",
            headline: p.title,
            datePublished: p.date,
            url: `${SITE_URL}/blog/${p.slug}`,
          })),
        }),
        ldScript(
          buildBreadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Blog", path: "/blog" },
          ]),
        ),
      ],
    }),
  component: BlogIndex,
});

function BlogIndex() {
  return (
    <>
      <Header />
      <main className="pt-32 pb-20 bg-background">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-foreground mb-4">The Atlanta Luxury Sprinters Blog</h1>
          <p className="text-muted-foreground text-lg mb-12">Straight answers on booking luxury transportation in Atlanta.</p>
          <div className="space-y-6">
            {BLOG_POSTS.map((p) => (
              <Link
                key={p.slug}
                to={p.path}
                className="block luxury-card rounded-lg p-6 hover:shadow-xl transition-all group"
              >
                <time dateTime={p.date} className="text-sm text-muted-foreground">{formatPostDate(p.date)}</time>
                <h2 className="font-heading text-2xl font-semibold text-foreground mt-2 mb-3 group-hover:text-primary transition-colors">{p.title}</h2>
                <p className="text-muted-foreground">{p.excerpt}</p>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
      <FloatingButtons />
    </>
  );
}
